import React from "react";

interface FunnelPMSIconProps {
    width?: number;
    height?: number;
}

const FunnelPMSIcon = ({
    width = 48,
    height = 48,
}: FunnelPMSIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Background */}
            <rect width="48" height="48" rx="10" fill="#51ab86" />

            {/* Funnel Shape */}
            <path
                d="M14 14H34L27 23V32L21 35V23L14 14Z"
                fill="white"
            />

            {/* Top Line */}
            <rect
                x="14"
                y="12"
                width="20"
                height="2"
                rx="1"
                fill="white"
                opacity="0.8"
            />
        </svg>
    );
};

export default FunnelPMSIcon;